/** One manifest per document, including direct SSR entry and SPA navigation. */
export function PwaHead({ pathname, production }: { pathname: string; production: boolean }) {
  const driver = pathname === "/driver" || pathname.startsWith("/driver/");
  return (
    <>
      <meta name="theme-color" content={driver ? "#0F1419" : "#FBFAF7"} />
      {production && <>
        <link rel="manifest" href={driver ? "/driver-manifest.webmanifest" : "/site.webmanifest"} />
        <meta name="apple-mobile-web-app-title" content={driver ? "Lecmo Driver" : "Lecmo"} />
      </>}
    </>
  );
}
